if (!window.Maximize.loadedScript.includes("store-locations.js")) {
  window.Maximize.loadedScript.push("store-locations.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xStoreLocations", (sectionId) => ({
        show: false,
        init() {
          document.addEventListener(`${STORE_MAP_EVENT.openPopup}`, () => {
            this.openPopup();
          });

          if (Shopify.designMode) {
            document.addEventListener("shopify:section:select", (event) => {
              if (event.target.classList.contains("section-store-locations")) {
                this.openPopup();
              }
            });
          }
        },
        openPopup() {
          this.show = true;
          Alpine.store("xMaximizePopup").handleOpen();
          Alpine.store("xMaximizeDrawer").activeDrawerElement = window.Maximize.isShowPopupOverlay;
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent("maximize:store-locations:init"));
            window.dispatchEvent(new Event("resize"));
          }, 300);
        },
        closePopup() {
          this.show = false;
          Alpine.store("xMaximizePopup").handleClose();
        }
      }));
    });
  });
}
